import React from 'react';
import Table, { TableProps } from '@mui/material/Table';

export default function ResponsiveTable(props: TableProps) {
    return (
        <div style={{ display: 'block', overflowX: 'auto' }}>
            <Table {...props} />
        </div>
    );
}